// @generated by protoc-gen-es v2.10.0 with parameter "target=ts,import_extension=none"
// @generated from file proto/sem/middleware/mode_evaluation.proto (package sem.middleware.mode_evaluation, syntax proto3)
/* eslint-disable */

import type { Message } from "@bufbuild/protobuf";
import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/sem/middleware/mode_evaluation.proto.
 */
export const file_proto_sem_middleware_mode_evaluation: GenFile = /*@__PURE__*/
  fileDesc("Cipwcm90by9zZW0vbWlkZGxld2FyZS9tb2RlX2V2YWx1YXRpb24ucHJvdG8SHnNlbS5taWRkbGV3YXJlLm1vZGVfZXZhbHVhdGlvbiJrChVNb2RlRXZhbHVhdGlvblBheWxvYWQSFAoMY3VycmVudF9tb2RlGAEgASgJEhAKCGFuYWx5c2lzGAIgASgJEhAKCGRlY2lzaW9uGAMgASgJEhgKEHJlY29tbWVuZGVkX21vZGUYBCABKAkibQoVTW9kZUV2YWx1YXRpb25TdGFydGVkEg8KB2l0ZW1faWQYASABKAkSQwoEZGF0YRgCIAEoCzI1LnNlbS5taWRkbGV3YXJlLm1vZGVfZXZhbHVhdGlvbi5Nb2RlRXZhbHVhdGlvblBheWxvYWQibAoUTW9kZUV2YWx1YXRpb25VcGRhdGUSDwoHaXRlbV9pZBgBIAEoCRJDCgRkYXRhGAIgASgLMjUuc2VtLm1pZGRsZXdhcmUubW9kZV9ldmFsdWF0aW9uLk1vZGVFdmFsdWF0aW9uUGF5bG9hZCKPAQoXTW9kZUV2YWx1YXRpb25Db21wbGV0ZWQSDwoHaXRlbV9pZBgBIAEoCRJDCgRkYXRhGAIgASgLMjUuc2VtLm1pZGRsZXdhcmUubW9kZV9ldmFsdWF0aW9uLk1vZGVFdmFsdWF0aW9uUGF5bG9hZBIPCgdzdWNjZXNzGAMgASgIEg0KBWVycm9yGAQgASgJQlZaVGdpdGh1Yi5jb20vdGVhbS1tZW50by9tZW50by1wbGF5Z3JvdW5kL2dvL3BrZy9zZW0vcGIvcHJvdG8vc2VtL21pZGRsZXdhcmU7bWlkZGxld2FyZWIGcHJvdG8z");

/**
 * @generated from message sem.middleware.mode_evaluation.ModeEvaluationPayload
 */
export type ModeEvaluationPayload = Message<"sem.middleware.mode_evaluation.ModeEvaluationPayload"> & {
  /**
   * @generated from field: string current_mode = 1;
   */
  currentMode: string;

  /**
   * @generated from field: string analysis = 2;
   */
  analysis: string;

  /**
   * e.g., "continue" or "switch"
   *
   * @generated from field: string decision = 3;
   */
  decision: string;

  /**
   * @generated from field: string recommended_mode = 4;
   */
  recommendedMode: string;
};

/**
 * Describes the message sem.middleware.mode_evaluation.ModeEvaluationPayload.
 * Use `create(ModeEvaluationPayloadSchema)` to create a new message.
 */
export const ModeEvaluationPayloadSchema: GenMessage<ModeEvaluationPayload> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_mode_evaluation, 0);

/**
 * @generated from message sem.middleware.mode_evaluation.ModeEvaluationStarted
 */
export type ModeEvaluationStarted = Message<"sem.middleware.mode_evaluation.ModeEvaluationStarted"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.middleware.mode_evaluation.ModeEvaluationPayload data = 2;
   */
  data?: ModeEvaluationPayload;
};

/**
 * Describes the message sem.middleware.mode_evaluation.ModeEvaluationStarted.
 * Use `create(ModeEvaluationStartedSchema)` to create a new message.
 */
export const ModeEvaluationStartedSchema: GenMessage<ModeEvaluationStarted> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_mode_evaluation, 1);

/**
 * @generated from message sem.middleware.mode_evaluation.ModeEvaluationUpdate
 */
export type ModeEvaluationUpdate = Message<"sem.middleware.mode_evaluation.ModeEvaluationUpdate"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.middleware.mode_evaluation.ModeEvaluationPayload data = 2;
   */
  data?: ModeEvaluationPayload;
};

/**
 * Describes the message sem.middleware.mode_evaluation.ModeEvaluationUpdate.
 * Use `create(ModeEvaluationUpdateSchema)` to create a new message.
 */
export const ModeEvaluationUpdateSchema: GenMessage<ModeEvaluationUpdate> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_mode_evaluation, 2);

/**
 * @generated from message sem.middleware.mode_evaluation.ModeEvaluationCompleted
 */
export type ModeEvaluationCompleted = Message<"sem.middleware.mode_evaluation.ModeEvaluationCompleted"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.middleware.mode_evaluation.ModeEvaluationPayload data = 2;
   */
  data?: ModeEvaluationPayload;

  /**
   * @generated from field: bool success = 3;
   */
  success: boolean;

  /**
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message sem.middleware.mode_evaluation.ModeEvaluationCompleted.
 * Use `create(ModeEvaluationCompletedSchema)` to create a new message.
 */
export const ModeEvaluationCompletedSchema: GenMessage<ModeEvaluationCompleted> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_mode_evaluation, 3);

